import { JOBS } from "@/react/routing/constants";
import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { customerJobsUrl, jobsBaseUrl } from "./urls";
import { oktaTokenBaseQuery } from "@/react/services/api/api";

export const jobsApi = createApi({
  baseQuery: oktaTokenBaseQuery(jobsBaseUrl),
  reducerPath: "jobs",
  endpoints: (build) => ({
    getAllCustomerJobs: build.query({
      queryFn: async (args, { getState }, _, fetch) => {
        try {
          const response = await fetch(customerJobsUrl(getState));
          return { data: response.data };
        } catch (error) {
          throw new Error(`Failed to fetch Jobs: ${error.message}`);
        }
      },
      providesTags: [JOBS],
    }),
    getCustomerJobsByType: build.query({
      queryFn: async (args, { getState }, _, fetch) => {
        try {
          const response = await fetch(
            `${customerJobsUrl(getState)}/types/${args.type}`
          );
          return { data: response.data };
        } catch (error) {
          throw new Error(`Failed to fetch Jobs: ${error.message}`);
        }
      },
      providesTags: [JOBS],
    }),
  }),
});

export const { useGetAllCustomerJobsQuery, useGetCustomerJobsByTypeQuery } =
  jobsApi;
